import Vue from 'vue'
import { getDates } from './utils/helpers'

export default {
	namespaced: true,
	state: {
		allPayments: [],
		allPaymentsByUser: [],
		workersPayments: [],
		usersPayments: [],
		date: {
			all: getDates(),
			users: getDates(),
			workers: getDates()
		},
		reports: {
			all: new ArrayBuffer(),
			users: new ArrayBuffer(),
			workers: new ArrayBuffer(),
		},
		isDownload: false,
	},
	actions: {
		async fetchAll({ commit, state }) {
			const { start, end } = state.date.all
			let response = await Vue.http.get(
				`pays?date_start=${start}&date_end=${end}`
			)
			commit('setAll', response.body)
		},
		async fetchPersonalPays({ commit, state }, date) {
			const { start, end } = date
			let response = await Vue.http.get(
				`pays/user?date_start=${start}&date_end=${end}`
			)
			commit('setAllPaymentsByUser', response.body)
		},
		async fetchPaysByUser({ commit, state }, payload) {
			const userId = payload.userId
			const { start, end } = payload.date
			let response = await Vue.http.get(
				`pays/user/${userId}?date_start=${start}&date_end=${end}`
			)
			commit('setAllPaymentsByUser', response.body)
		},
		async fetchUsers({ commit, state }) {
			const { start, end } = state.date.users
			let response = await Vue.http.get(
				`pays/group/user?date_start=${start}&date_end=${end}`
			)
			commit('setUsers', response.body)
		},
		async fetchWorkers({ commit, state }) {
			const { start, end } = state.date.workers
			let response = await Vue.http.get(
				`pays/group/worker?date_start=${start}&date_end=${end}`
			)
			commit('setWorkers', response.body)
		},
		async exportReport({ commit, state }, query) {
			try {
				commit('setLoadingReport', true)
				const user = query.type.includes('user')
				const worker = query.type.includes('worker')
				const { start, end } = state.date[query.type]

				const queryData = {
					date_start: start,
					date_end: end,
					group_user: user,
					group_worker: worker,
					headers: query.headers.join(','),
				}

				let response = await Vue.http.get(
					`pays/download`,
					{
						responseType: 'arraybuffer',
						params: queryData
					}
				)
				commit('setReports', { report: response.body, type: query.type })
				commit('setLoadingReport', false)
			} catch (e) {
				commit('setLoadingReport', false)
			}
		}
	},
	mutations: {
		setAll(state, allPayments) {
			state.allPayments = [...allPayments]
		},
		setAllPaymentsByUser(state, allPaymentsByUser) {
			state.allPaymentsByUser = [...allPaymentsByUser]
		},
		setUsers(state, payments) {
			state.usersPayments = [...payments]
		},
		setWorkers(state, payments) {
			state.workersPayments = [...payments]
		},
		setReports(state, { type, report }) {
			state.reports[type] = report
		},
		setLoadingReport(state, status) {
			state.isDownload = status
		}
	}
}
